import {
    FETCH_BALANCE_SUCCEEDED,
} from "../../constants/ActionTypes";

const initialState = {
    monetary: null,
    credit: null,
    sms: [],
};

const balance = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BALANCE_SUCCEEDED:
            return {
                ...state,
                sms: action.balance.sms,
                monetary: action.balance.monetary,
                credit: action.balance.credit,
            };
        default:
            return state;
    }
};

export default balance;
